export default __webpack_public_path__ + "static/media/permissions-illustration1.453d5a69.svg";